module.exports = __webpack_public_path__ + "revicons.1142a254da20b59e7d10.svg";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/components/revolution_slider/fonts/revicons/revicons.svg?5510888
// module id = ../../../../../src/assets/components/revolution_slider/fonts/revicons/revicons.svg?5510888
// module chunks = 2